import { videoFetch } from './video-http';

export const API = '/api/2026-09';
export class ApiError extends Error {
  constructor(readonly status: number, message: string) { super(message); }
}

export async function apiRequest<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await videoFetch(path, { credentials: 'same-origin', ...options });
  if (response.redirected || response.headers.get('Content-Type')?.includes('text/html')) {
    throw new ApiError(401, 'Sign in to render and download your videos.');
  }
  const value = await response.json().catch(() => null) as { error?: { message?: string } } | null;
  if (!response.ok) throw new ApiError(response.status, value?.error?.message ?? 'The request could not be completed.');
  return value as T;
}

export const jsonPost = (body: unknown): RequestInit => ({ method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
